module.exports = __webpack_public_path__ + "static/media/IMG_0445 (1).e2b1adfd.JPG";